import React, { useMemo } from 'react';
import { Checkbox, Flex, Typography } from 'antd';
import { EstimateStatus } from '@shared/utils/constants';
import { standardSort } from '@shared/utils/standardSort';
import type { CargoTypeProps } from '@api/models/cargo-type';
import Table from '@client/components/Table/Table';
import { useCargoProvider } from '@client/screens/estimates/details/context/CargoContext';
import { useEstimate } from '@client/screens/estimates/details/context/EstimatorContext';
import getIntakeCargoColumns from './helpers/getIntakeCargoColumns';

const IntakeCalculatorCargosTable = ({
	cargoTypes,
	showAllPorts,
	setShowAllPorts,
}: {
	cargoTypes: CargoTypeProps[];
	showAllPorts: boolean;
	setShowAllPorts: (s: boolean) => void;
}) => {
	const {
		cargos,
		onUpdateCargo,
		portOptions,
	} = useCargoProvider();

	const { estimate } = useEstimate();

	const disabled = estimate?.status === EstimateStatus.Fixed;

	const sortedCargos = useMemo(() => [...cargos].sort(standardSort('id')), [cargos]);

	const columns = useMemo(() => getIntakeCargoColumns({
		onUpdateCargo,
		cargoTypes,
		portOptions,
		disabled,
	}), [onUpdateCargo, cargoTypes, portOptions, disabled]);

	return (
		<Flex vertical gap={1}>
			<Flex align="center" gap={10}>
				<Typography.Title level={4}>
					Cargo details
				</Typography.Title>
				<Checkbox
					checked={showAllPorts}
					onChange={(e) => setShowAllPorts(e.target.checked)}
					style={{ marginBottom: 5 }}
				>
					Show all ports
				</Checkbox>
			</Flex>
			<Table
				rowKey="id"
				size="small"
				bordered
				pagination={false}
				columns={columns}
				dataSource={sortedCargos}
				emptyText="No cargos"
				scroll={{ x: 'max-content' }}
			/>
		</Flex>
	);
};

export default IntakeCalculatorCargosTable;
